<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<form [formGroup]="formGroup" (ngSubmit)="confirm()">
  <mat-dialog-content>
    <p>{{ data.message | translate }}</p>

    @if (data.warning) {
      <dbx-banner fontIcon="warning">{{ data.warning | translate }}</dbx-banner>
    }

    @if (data.mfaRequired && !isLoading()) {
      <p>{{ 'login.verifyCodeInstruction' | translate }}</p>
      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'login.code' | translate }}</mat-label>
          <input matInput name="mfaCode" formControlName="mfaCode" maxlength="6" />
          <mat-error>
            @if (formGroup.get('mfaCode')?.hasError('required')) {
              {{ 'login.errors.codeRequired' | translate }}
            }
            @if (formGroup.get('mfaCode')?.hasError('minlength') || formGroup.get('mfaCode')?.hasError('maxlength')) {
              {{ 'login.errors.codeLength' | translate }}
            }
          </mat-error>
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (data.type === AlertDialogType.Danger) {
      <button mat-button cdkFocusInitial type="button" (click)="close({ confirmed: false })"
        >{{ 'common.cancel' | translate }}
      </button>
      <button
        mat-flat-button
        [class]="AlertDialogType.buttonClassName(data.type)"
        [disabled]="formGroup.invalid || isLoading()"
        type="submit"
      >
        <span class="loading-button-container">
          <span [style.visibility]="isLoading() ? 'hidden' : 'visible'">
            {{ AlertDialogType.name(data.type) | translate }}
          </span>
          @if (isLoading()) {
            <mat-spinner diameter="20" />
          }
        </span>
      </button>
    } @else {
      <button mat-button type="button" (click)="close({ confirmed: false })">{{ 'common.cancel' | translate }}</button>
      <button
        mat-flat-button
        cdkFocusInitial
        [class]="AlertDialogType.buttonClassName(data.type)"
        [disabled]="formGroup.invalid || isLoading()"
        type="submit"
      >
        <span class="loading-button-container">
          <span [style.visibility]="isLoading() ? 'hidden' : 'visible'">
            {{ AlertDialogType.name(data.type) | translate }}
          </span>
          @if (isLoading()) {
            <mat-spinner diameter="20" />
          }
        </span>
      </button>
    }
  </mat-dialog-actions>
</form>
